import { useEffect } from 'react';

const AdBanner = () => {
  useEffect(() => {
    try {
      (window.adsbygoogle = window.adsbygoogle || []).push({});
    } catch (e) {
      console.error('Adsbygoogle error:', e);
    }
  }, []); // ✅ This semicolon is correct and closes the useEffect hook

  return (
    <ins className="adsbygoogle"
         style={{ display: 'block', margin: '20px 0' }}
         data-ad-client="ca-pub-1751699265073005"
         data-ad-slot="6102185909"
         data-ad-format="auto"
         data-full-width-responsive="true"></ins>
  ); // ✅ This semicolon is also correct and closes the return statement
};

export default AdBanner; // ✅ This ends the component definition
